import _objectSpread from "D:/nodeApp/hj-aadmin-vue-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { mapActions } from 'vuex';
import config from '@/settings';
import { getCaptcha } from '@/api/login';
import axios from 'axios';
import VerifyTwofa from '@/views/admin/login/VerifyTwofa';
export default {
  components: {
    VerifyTwofa: VerifyTwofa
  },
  data: function data() {
    return {
      loading: false,
      config: config,
      capImg: '',
      ruleForm: {
        username: '',
        password: '',
        captcha: '',
        real_ip: '8.8.8.8',
        ckey: ''
      },
      rules: {
        username: [{
          required: true,
          message: this.$t('common.username') + this.$t('common.ruleMsg.require'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('common.password') + this.$t('common.ruleMsg.require'),
          trigger: 'blur'
        }],
        captcha: [{
          required: true,
          message: this.$t('common.captcha') + this.$t('common.ruleMsg.require'),
          trigger: 'blur'
        }]
      },
      redirect: undefined,
      otherQuery: {}
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {
    this.roundCap();
    this.getIp();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('user', ['loginHandle'])), {}, {
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.loading = true;
          _this.loginHandle(_objectSpread({}, _this.ruleForm)).then(function (data) {
            if (data.isOpen2fa) {
              // 打开2fa窗口
              _this.$refs.verify2fa.open(data.twofa_token);
            } else {
              _this.loginSuccess();
            }
          }).catch(function () {
            _this.roundCap();
            _this.ruleForm.captcha = '';
            _this.$notify({
              title: 'Login failed',
              message: 'Please check whether the account name or password and verification code are correct. If you have any questions, please contact the administrator.',
              type: 'warning'
            });
          }).finally(function () {
            _this.loading = false;
          });
        }
      });
    },
    loginSuccess: function loginSuccess() {
      this.$router.push({
        path: this.redirect || '/',
        query: this.otherQuery
      }).catch(function (error) {
        console.info(error.message);
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submit: function submit() {
      this.submitForm('ruleForm');
    },
    roundCap: function roundCap() {
      var _this2 = this;
      getCaptcha().then(function (result) {
        _this2.ruleForm.ckey = result.data.key;
        _this2.capImg = result.data.img;
      }).catch(function () {
        _this2.$notify({
          title: 'Failed to obtain verification code',
          message: 'Failed to obtain the verification code. Please do not refresh frequently. Please try again later.',
          type: 'warning'
        });
      });
    },
    getIp: function getIp() {
      var _this3 = this;
      axios.get('https://icanhazip.com/').then(function (res) {
        _this3.ruleForm.real_ip = res.data;
      }).catch(function () {});
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    }
  })
};